module.exports = __webpack_public_path__ + "static/img/re_cdd.4bd98651.png";